import { create } from "zustand";

export const useGtt = create((set) => ({
  dialog: null,
  version: 0,
  openGtt: (o = {}) => set({ dialog: { kind: "gtt", ...o } }),
  openAlert: (o = {}) => set({ dialog: { kind: "alert", ...o } }),
  close: () => set({ dialog: null }),
  bump: () => set((s) => ({ version: s.version + 1 })),
}));

export const CONDITIONS = [
  ["above", "Price ≥", "₹"],
  ["below", "Price ≤", "₹"],
  ["pct_up", "Day change ≥ +", "%"],
  ["pct_down", "Day change ≤ −", "%"],
];

export const conditionLabel = (a) => {
  const c = CONDITIONS.find((x) => x[0] === a.condition);
  return c ? `${c[1]}${c[2] === "₹" ? " ₹" : ""}${a.value}${c[2] === "%" ? "%" : ""}` : a.condition;
};
